/* Münz-Kachel: Vorhang, Heranfahren und Aufstieg der Münze setzen genau dann ein,
   wenn die Kachel wirklich in den Blick kommt.

   Grund: Das Bewegungssystem des Themes markiert Elemente schon beim Laden der Seite
   als sichtbar - auch solche weit unterhalb des Bildes. Die Bewegung lief dadurch
   unbemerkt ab, bevor man hinsah.

   Kein Dauerlauf, kein Zeitgeber: jedes Element wird genau einmal ausgelöst und danach
   nicht mehr beobachtet (Hausordnung MOTION.md). Ohne dieses Skript bleibt die Kachel
   einfach fertig stehen - es wird nichts versteckt. */
(function () {
  'use strict';

  var kacheln = document.querySelectorAll('.product-card.muenz-kachel');
  if (!kacheln.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function ausloesen(kachel) {
    kachel.classList.add('ist-offen');
  }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(kacheln, ausloesen);
    return;
  }

  var beobachter = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      ausloesen(e.target);
      beobachter.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -16% 0px', threshold: 0.22 });

  Array.prototype.forEach.call(kacheln, function (k) { beobachter.observe(k); });
})();
